import { AlignmentType, convertMillimetersToTwip, LevelFormat } from "docx";

export const numberingStyle = {
  config: [
    {
      reference: "numbering",
      levels: [
        {
          level: 0,
          format: LevelFormat.DECIMAL,
          text: "%1.",
          basedOn: "normal",
          alignment: AlignmentType.START,
          style: {
            paragraph: {
              indent: { left: 520, hanging: 260 },
            },
          },
        },
        {
          level: 1,
          format: LevelFormat.UPPER_ROMAN,
          text: "%2.",
          basedOn: "normal",
          alignment: AlignmentType.START,
          style: {
            paragraph: {
              indent: { left: 1440, hanging: 980 },
            },
          },
        },
        {
          level: 2,
          format: LevelFormat.LOWER_LETTER,
          text: "%3)",
          basedOn: "normal",
          alignment: AlignmentType.START,
          style: {
            paragraph: {
              indent: { left: 2160, hanging: 1700 },
            },
          },
        },
        {
          level: 3,
          format: LevelFormat.UPPER_LETTER,
          text: "%4)",
          basedOn: "normal",
          alignment: AlignmentType.START,
          style: {
            paragraph: {
              indent: { left: 2880, hanging: 2420 },
            },
          },
        },
      ],
    },
    {
      reference: "simpleNumbering",
      levels: [
        {
          level: 0,
          format: LevelFormat.DECIMAL,
          text: "%1.",

          style: {
            paragraph: {
              indent: {
                hanging: convertMillimetersToTwip(6.3),
                left: convertMillimetersToTwip(6.3 + 6.3),
              },
            },
          },
        },
        {
          level: 1,
          format: LevelFormat.DECIMAL,
          text: "%2.",

          style: {
            paragraph: {
              indent: {
                hanging: convertMillimetersToTwip(6.3),
                left: convertMillimetersToTwip(6.3 + 19),
              },
            },
          },
        },
        {
          level: 2,
          format: LevelFormat.DECIMAL,
          text: "%3.",
          style: {
            paragraph: {
              indent: {
                hanging: convertMillimetersToTwip(6.3),
                left: convertMillimetersToTwip(6.3 + 31.8),
              },
            },
          },
        },
        {
          level: 3,
          format: LevelFormat.DECIMAL,
          text: "%4.",
          style: {
            paragraph: {
              indent: {
                hanging: convertMillimetersToTwip(6.3),
                left: convertMillimetersToTwip(6.3 + 44.4),
              },
            },
          },
        },
        {
          level: 4,
          format: LevelFormat.DECIMAL,
          text: "%5.",
          style: {
            paragraph: {
              indent: {
                hanging: convertMillimetersToTwip(6.3),
                left: convertMillimetersToTwip(6.3 + 57.1),
              },
            },
          },
        },
        {
          level: 5,
          format: LevelFormat.DECIMAL,
          text: "%6.",
          style: {
            paragraph: {
              indent: {
                hanging: convertMillimetersToTwip(6.3),
                left: convertMillimetersToTwip(6.3 + 69.9),
              },
            },
          },
        },
        {
          level: 6,
          format: LevelFormat.DECIMAL,
          text: "%7.",
          style: {
            paragraph: {
              indent: {
                hanging: convertMillimetersToTwip(6.3),
                left: convertMillimetersToTwip(6.3 + 82.5),
              },
            },
          },
        },
        {
          level: 7,
          format: LevelFormat.DECIMAL,
          text: "%8.",
          style: {
            paragraph: {
              indent: {
                hanging: convertMillimetersToTwip(6.3),
                left: convertMillimetersToTwip(6.3 + 95.2),
              },
            },
          },
        },
        {
          level: 8,
          format: LevelFormat.DECIMAL,
          text: "%9.",
          style: {
            paragraph: {
              indent: {
                hanging: convertMillimetersToTwip(6.3),
                left: convertMillimetersToTwip(6.3 + 107.9),
              },
            },
          },
        },
      ],
    },
  ],
};
